"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_NAME_EXISTS_ERROR = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const TitleLabel = (0, material_1.styled)(material_1.Typography)({
    fontWeight: "bold",
});
const FormControlContainer = (0, material_1.styled)(material_1.FormControl)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    marginRight: "auto",
}));
exports.SEARCH_NAME_EXISTS_ERROR = "please specify another name. there is already a record with the given name.";
const SaveSearchDialog = ({ onSave, onCancel, saveSearchError, onSaveSearchResetError, }) => {
    const [title, setTitle] = (0, react_1.useState)("");
    const [viewableByAll, setViewableByAll] = (0, react_1.useState)(false);
    const [errorState, setErrorState] = (0, react_1.useState)(false);
    const [helperText, setHelperText] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (saveSearchError?.message === exports.SEARCH_NAME_EXISTS_ERROR) {
            setErrorState(true);
            setHelperText(exports.SEARCH_NAME_EXISTS_ERROR);
        }
    }, [saveSearchError]);
    (0, react_1.useEffect)(() => () => {
        setErrorState(false);
        setHelperText(null);
        onSaveSearchResetError();
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Dialog, { "data-testid": "SaveSearchDialog_root", fullWidth: true, open: true, onClose: onCancel, "aria-labelledby": "form-dialog-title" },
            react_1.default.createElement(material_1.DialogTitle, { id: "form-dialog-title" },
                react_1.default.createElement(TitleLabel, { variant: "h6" }, "Save search")),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.TextField, { autoFocus: true, variant: "filled", margin: "dense", label: "Search Title", fullWidth: true, required: true, value: title, onChange: (e) => setTitle(e.target.value), error: errorState, helperText: helperText })),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(FormControlContainer, null,
                    react_1.default.createElement(material_1.FormLabel, { component: "legend" }, "Who can see this"),
                    react_1.default.createElement(material_1.FormGroup, null,
                        react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { color: "primary", checked: viewableByAll, onChange: () => {
                                    setViewableByAll(!viewableByAll);
                                }, name: "everyone" }), label: react_1.default.createElement(material_1.Typography, { variant: "body2" }, "Everyone") }))),
                react_1.default.createElement(material_1.Button, { onClick: onCancel }, "Cancel"),
                react_1.default.createElement(material_1.Tooltip, { arrow: true, placement: "top-end", title: !title ? "Title is required" : "" },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(material_1.Button, { variant: "contained", disabled: !title, onClick: () => onSave({ title, viewableByAll }), color: "primary" }, "Save")))))));
};
exports.default = SaveSearchDialog;
